<template>
  <page :custom-style="{ height: '100vh' }">
    <template v-for="item in guideImgs">
      <div v-if="item.id > disappearIndex" :key="item.id" class="guide-img">
        <img :src="item.url" alt="guide引导图" />
      </div>
    </template>
    <div class="rainBox">
      <template v-if="!gameStatus">
        <div class="main-tips">
          <img :src="mainTipsImg" />
          <div class="desc-wrapper">
            <p>每日登陆即可参与</p>
            <p>下单满120元再获得一次抽奖机会</p>
          </div>
        </div>
        <div class="bg-wrapper">
          <img
            src="@/images/redPackageRain/bg_page_bottom.png"
            class="bg-center"
          />
        </div>
        <div class="bottom-container">
          <div class="bottom-control">
            <div class="rules-box" @click="goRules">
              <img
                src="@/images/redPackageRain/activity_rules.png"
                alt="活动规则"
              />
            </div>
            <div class="start-btn-box">
              <div class="start-btn" @click="startCountDown">
                <img
                  src="@/images/redPackageRain/start_btn.png"
                  alt="开始按钮"
                />
              </div>
              <div v-if="drawCount <= 5" class="chance">
                <img src="@/images/redPackageRain/chance/chance_left.png" />
                <img class="num" :src="chanceImgs[drawCount]" alt="抽奖机会" />
                <img src="@/images/redPackageRain/chance/chance_right.png" />
              </div>
            </div>
            <div class="back-box" @click="backPrevPage">
              <img src="@/images/redPackageRain/back_home.png" alt="回首页" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="start-count-down-wrapper"
          :class="gameStatus === 1 ? 'count-down' : ''"
        >
          <div v-if="gameStatus === 1" class="start-count-down-box">
            <img
              :src="countDownImgs[startSecond - 1]"
              alt="倒计时数字"
              class="start-count-cown-num"
            />
          </div>
          <ul v-if="packageParams.length" id="package-wrapper">
            <li
              v-for="(item, index) in packageParams"
              :key="index"
              :class="['package', item.status ? 'selected' : '']"
              :style="{
                left: item.left,
                animationDuration: item.durTime,
                webkitAnimationDuration: item.durTime
              }"
              @webkitAnimationEnd="removeDom"
              @touchstart.stop="clickPackage($event, item)"
            >
              <div
                class="package-inner"
                :style="{
                  transform: item.transforms,
                  webkitTransform: item.transforms
                }"
              >
                <img
                  src="@/images/redPackageRain/hongbao.png"
                  alt=""
                  class="package-img"
                  :class="{ 'package-img-open': item.status === 1 }"
                />
                <div v-if="item.status === 1" class="coin-img-box">
                  <img
                    src="@/images/redPackageRain/coin.png"
                    alt=""
                    class="coin-img"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="gameStatus !== 1" class="top-info">
          <div class="time-box">
            <div class="time-text-wrapper">
              <span>剩余时间</span>
              <span class="time-num">{{ duration }}秒</span>
            </div>
            <div class="step-progress-box">
              <div
                class="step-progress-img-wrapper"
                :class="{ 'step-progress-move': gameStatus === 2 }"
              >
                <img src="@/images/redPackageRain/schedule.png" />
              </div>
            </div>
          </div>
          <div class="package-num-box">{{ selectedNum }}个</div>
        </div>
      </template>
    </div>
    <mc-mask :show="showLotteryMask">
      <div class="award-wrapper">
        <div class="award-box">
          <img
            v-if="!lotteryLuck"
            :src="luckyWordImg"
            class="lose-lottery-img"
            @click="clickMask"
          />
          <div
            v-else
            class="lottery-lucky-box"
            :style="{ backgroundImage: `url(${lotteryLuckBgImg})` }"
            @click="goLotteryUrl"
          >
            <div class="lottery-lucky-text-box">
              <div class="text" style="font-size: 0.4rem">恭喜您获得</div>
              <div class="text" style="font-size: 0.64rem">
                {{ lotteryPrice }}元
              </div>
              <div class="text" style="font-size: 0.4rem">优惠礼包</div>
            </div>
          </div>
        </div>
        <img
          src="@/images/icon/close.png"
          class="closedbtn"
          @click="clickMask"
        />
      </div>
    </mc-mask>
  </page>
</template>
<script>
import { API } from '@/api'
import mcMask from '@/common/widgets/mask'
// import { miniProgramEnv } from '@/defines/environment'
import { appendQueryString } from '@/utils/urlUtil'
import { _rem } from '@/utils/global'
import {
  loseLottery0Img,
  loseLottery1Img,
  loseLottery2Img,
  loseLottery3Img,
  loseLottery4Img,
  mainTipsImg,
  lotteryLuckBgImg
} from '@/defines/environment/config'
// import { $_rem } from 'app/utils/global'
// import { handleLogin, Utils } from 'app/utils/Mixins'
// import backMixin from 'app/mixins/goback'
const configuration = {
  gameStatus: 0, // 游戏状态：0 未开始，1 开始倒计时阶段， 2 游戏正式开始
  startSecond: 3, // 游戏准备开始倒计时
  duration: 15 // 游戏持续时间s
}
export default {
  components: {
    mcMask
  },
  // mixins: [backMixin],
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      // eslint-disable-next-line camelcase
      const { lottery_activity_id } = to.query
      // eslint-disable-next-line camelcase
      vm.lotteryActivityId = lottery_activity_id
      await vm.getDrawCount()
      vm.initData()
    })
  },
  data() {
    return {
      gameStatus: configuration.gameStatus,
      startSecond: configuration.startSecond, // 游戏准备开始倒计时
      packageParams: [], // 红包数组
      createPackageTimer: null, // 创建红包的定时器
      duration: configuration.duration, // 游戏持续时间s
      selectedNum: 0, // 选中红包个数，不超过3个
      showLotteryMask: false, // 展示抽奖结果蒙层
      drawCount: 0, // 剩余抽奖次数
      countDownImgs: [], // 开始倒计时的图片集合
      chanceImgs: [], // 还有几次集合的图片集合
      lotteryLuck: false, // 是否抽中
      luckyWordImgs: [
        loseLottery0Img,
        loseLottery1Img,
        loseLottery2Img,
        loseLottery3Img,
        loseLottery4Img
      ], // 吉祥话图片数组集合
      guideImgs: [], // 引导图图片集合
      disappearIndex: -1, // 需要消失的引导图index值
      lotteryPrice: 0, // 中奖金额
      lotteryActivityId: 0, // 活动id
      lotteryH5Url: '',
      lotteryAppUrl: '',
      luckyWordImg: '',
      mainTipsImg,
      lotteryLuckBgImg
    }
  },
  computed: {
    startCountDownImg() {
      return this.countDownImgs[this.startSecond - 1]
    }
  },
  created() {
    this.getImages()
  },
  mounted() {
    this.handleDisappearImg()
  },
  methods: {
    // 动态引入本地图片
    getImages() {
      ;[1, 2, 3].forEach(item => {
        this.countDownImgs.push(
          require(`@/images/redPackageRain/count_down${item}.png`)
        )
      })
      ;[0, 1, 2, 3, 4, 5].forEach((item, index) => {
        this.chanceImgs.push(
          require(`@/images/redPackageRain/chance/chance${item}.png`)
        )
      })
    },
    /**
     * 处理初始化引导图
     * 以设备为维度，如果是首次进入，则展示引导图，否则不展示
     */
    handleDisappearImg() {
      if (!localStorage.getItem('mc_red_package_rain')) {
        localStorage.setItem('mc_red_package_rain', true)
        ;[2, 1, 0].forEach(item => {
          this.guideImgs.push({
            id: item,
            url: require(`@/images/redPackageRain/guide/guide${item}.jpg`)
          })
        })
        const disappearTimer = setInterval(() => {
          this.disappearIndex++
          if (this.disappearIndex === 2) clearInterval(disappearTimer)
        }, 1500)
      }
    },
    initData() {
      this.gameStatus = configuration.gameStatus
      this.startSecond = configuration.startSecond // 游戏准备开始倒计时
      this.duration = configuration.duration // 游戏持续时间s
      this.selectedNum = 0 // 选中红包个数，不超过3个
      this.showLotteryMask = false // 展示抽奖结果蒙层
      this.lotteryLuck = false // 是否抽中
      this.lotteryPrice = 0 // 中奖金额
      this.packageParams = []
    },
    // 游戏准备开始倒计时
    startCountDown() {
      if (!this.drawCount) {
        return this.$toast('今日抽奖次数已用光哦')
      }
      this.gameStatus = 1
      this.refreshLuckyWordImg()
      const timer = setInterval(() => {
        if (this.startSecond === 1) {
          this.gameStatus = 2
          clearInterval(timer)
          this.startRedPacket()
          this.rainCountDown()
        } else {
          this.startSecond--
        }
      }, 1000)
    },
    // 游戏时间倒计时
    rainCountDown(startRainCountDown) {
      if (startRainCountDown) this.duration--
      if (this.duration === 0) {
        clearTimeout(this.createPackageTimer)
        this.packageParams.map(item => {
          if (!item.status) item.status = 2
        })
        if (this.selectedNum > 0) {
          this.getLotterResult()
        } else {
          this.getDecreaseDrawCount()
        }
      } else {
        setTimeout(() => {
          this.rainCountDown(true)
        }, 1000)
      }
    },
    // 点击红包
    clickPackage(e, item) {
      if (!item.status) {
        item.status = 1
        this.selectedNum++
      }
    },
    // 开始下红包雨
    startRedPacket() {
      const windowWidth =
        document.documentElement.clientWidth || document.body.clientWidth // 屏幕宽度
      const rotate = this.randomNum(-20, 20) // 随机旋转角度(-45deg - 45deg)
      const durTime = this.randomNum(19, 2) / 10 // 随机下落时间 (1.5 - 2)
      let left = parseInt(Math.random() * windowWidth) / _rem // 随机红包初始的位置
      const minLeft = 40 / _rem // 最小left临界值
      const maxLeft = 220 / _rem // 最大left临界值
      if (left < minLeft) {
        left = minLeft
      } else if (left > maxLeft) {
        left = maxLeft
      }

      this.packageParams.push({
        left: left + 'rem',
        transforms: `rotate(${rotate}deg)`,
        durTime: durTime + 's',
        status: 0 // 0: 默认, 1: 点中，2: 时间到
      })

      // 创建红包，控制密度
      this.createPackageTimer = setTimeout(() => {
        this.startRedPacket()
      }, 500)
    },
    // 移除已经出了屏幕的红包，回收dom节点，防止内存溢出
    removeDom(e) {
      if (
        e.target.className === 'package' ||
        e.target.className === 'coin-img'
      ) {
        // 因为animationend事件会冒泡，当子元素动画播完后也会触发这个方法，所以要判断下是红包动画播完或者金币散开动画播完后才回收dom
        const target = e.currentTarget
        document.querySelector('#package-wrapper').removeChild(target)
      }
    },
    clickMask() {
      if (!this.drawCount) {
        return this.$dialog
          .alert({
            confirmButtonText: '回首页',
            message: '今日抽奖次数用光啦'
          })
          .then(() => {
            this.backPrevPage()
          })
      }
      this.initData()
    },
    // 获取抽奖次数
    async getDrawCount() {
      try {
        const res = await API.redPackageRain.getDrawCount({
          lottery_activity_id: this.lotteryActivityId
        })
        this.drawCount = res.draw_count
      } catch (error) {
        this.$dialog.alert({
          confirmButtonText: '知道了',
          message: '请检查您的网络是否通畅'
        })
      }
    },
    /**
     * 抽奖次数减1的接口
     * 兼容红包个数为0的情况，此时需要调这个接口去减少抽奖次数
     */
    async getDecreaseDrawCount() {
      this.$Loading()
      try {
        const res = await API.redPackageRain.getDecreaseDrawCount({
          lottery_activity_id: this.lotteryActivityId
        })
        this.drawCount = res
      } catch (error) {
        return this.$dialog.alert({
          confirmButtonText: '知道了',
          message: '请检查您的网络是否通畅'
        })
      }
      this.showLotteryMask = true
      this.$Loading.hide()
    },
    /**
     * 开始抽奖
     * 该方法在data为空或者报错的时候均走默认未中奖
     */
    async getLotterResult() {
      this.$Loading()
      try {
        const res = await API.redPackageRain.getLotterResult({
          lottery_activity_id: this.lotteryActivityId,
          hit_count: this.selectedNum
        })
        if (res.status) {
          this.lotteryLuck = true
          this.lotteryPrice = res.prize.prize_value
          this.lotteryH5Url = res.prize.h5_url
          this.lotteryAppUrl = res.prize.app_url
        }
        // if (res.ret && res.data && res.data.status) {

        // } else if (res.error && Number(res.error.code) === 1012002) {
        //   this.$Loading.hide()
        //   // return handleLogin()
        // } else if (res.error) {
        //   this.$Loading.hide()
        //   return this.$Dialog.alert(res.error.msg, {
        //     confirmButtonText: '知道了'
        //   })
        // }
      } catch (error) {
        return this.$dialog.alert({
          confirmButtonText: '知道了',
          message: '请检查您的网络是否通畅'
        })
      }
      // 刷新抽奖次数
      await this.getDrawCount()
      this.$Loading.hide()
      this.showLotteryMask = true
    },
    backPrevPage() {
      this.$back()
    },
    goRules() {
      const url = appendQueryString(
        'https://material-page.yunshanmeicai.com/richText/1000626'
      )
      this.$autoRedirect(url)
    },
    goLotteryUrl() {
      const url = appendQueryString(this.lotteryAppUrl)
      this.$autoRedirect(url)
    },
    // 生成从minNum到maxNum的随机数
    randomNum(minNum, maxNum) {
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    },
    // 更新吉祥话
    refreshLuckyWordImg() {
      const index = this.randomNum(0, this.luckyWordImgs.length - 1)
      this.luckyWordImg = this.luckyWordImgs[index]
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  display: block;
}
.guide-img {
  position: absolute;

  z-index: 10;

  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.main-tips {
  display: flex;

  position: relative;
  z-index: 6;

  justify-content: center;
  align-items: flex-start;
  img {
    width: 100%;
  }
  .desc-wrapper {
    position: absolute;

    bottom: -1.2rem;

    width: 100%;

    font-size: 0.3rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
}
.rainBox {
  position: relative;
  transform: translate3d(0, 0, 0);

  width: 100%;
  height: 100%;

  margin: 0;

  padding: 0;

  overflow: hidden;

  background: url('../../images/redPackageRain/bg_page.png') no-repeat center;
  background-size: 100% 100%;

  .bg-wrapper {
    position: absolute;
    bottom: 0;
    .bg-center {
      width: 100%;
    }
  }

  .start-count-down-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;

    width: 100%;
    height: 100%;

    background: url('../../images/redPackageRain/bg_start_rain.png') no-repeat
      center;
    background-size: cover;
    &.count-down {
      background: url('../../images/redPackageRain/bg_start_count.png')
        no-repeat center;
      background-size: 100% 100%;
    }
    .start-count-down-box {
      display: flex;

      position: absolute;
      top: 30%;
      left: 50%;

      transform: translateX(-50%);

      width: max-content;

      flex-direction: column;
      align-items: center;
      img {
        display: block;
      }
      .start-count-cown-num {
        height: 3.88rem;
      }
    }
  }

  .bottom-container {
    position: absolute;

    bottom: 0.4rem;

    width: 100%;
    .bottom-control {
      display: flex;

      justify-content: space-around;
      align-items: flex-end;

      font-size: 0.28rem;
      .rules-box,
      .back-box {
        img {
          width: 1.2rem;
        }
      }
      .start-btn-box {
        position: relative;
        top: -30px;

        width: 3.6rem;
        .start-btn {
          img {
            width: 100%;
            height: 100%;
          }
        }
        .chance {
          display: flex;

          margin-top: 0.28rem;

          justify-content: center;
          align-items: center;
          img {
            height: 0.42rem;
            &.num {
              height: 0.5rem;
              margin: 0 0.1rem;
            }
          }
        }
      }
    }
  }

  .top-info {
    display: flex;

    position: relative;
    z-index: 6;

    width: 100%;
    height: 1rem;

    margin-top: 0.3rem;

    padding: 0 0.4rem;

    justify-content: space-between;
    align-items: center;

    font-size: 0.28rem;
    color: #171717;
    .time-box {
      width: 2.96rem;
      .time-text-wrapper {
        display: flex;

        height: 0.2rem;

        justify-content: space-between;
        align-items: center;

        line-height: 0.4rem;
        font-weight: bold;
        color: #d80600;
      }
      .step-progress-box {
        position: relative;

        height: 0.28rem;

        margin-top: 0.14rem;

        padding: 0.06rem;

        overflow: hidden;

        background: url('../../images/redPackageRain/bg_schedule.png') no-repeat
          center;
        background-size: 100% 100%;
        .step-progress-img-wrapper {
          display: flex;

          position: relative;

          width: 2.84rem;
          height: 0.16rem;

          overflow: hidden;

          background: #d80600;

          align-items: center;

          line-height: 0.16rem;
          &.step-progress-move {
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            animation: progress_move 15s linear forwards;
          }
          img {
            width: 2.84rem;
            height: 100%;

            vertical-align: top;
          }
        }
      }
    }
    .package-num-box {
      display: flex;

      width: 1.14rem;
      height: 1.24rem;

      padding-bottom: 0.14rem;

      background: url('../../images/redPackageRain/small_package.png') no-repeat
        top;

      justify-content: center;
      align-items: flex-end;

      font-size: 0.24rem;
      line-height: 0.4rem;
      font-weight: 500;
      color: #e1001c;

      background-size: 100% auto;
    }
  }
  /* stylelint-disable */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .desc-wrapper {
      bottom: -2rem !important;
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .desc-wrapper {
      bottom: -2rem !important;
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .desc-wrapper {
      bottom: -2rem !important;
    }
  }
  /* stylelint-enable */
}
.award-wrapper {
  display: flex;

  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  flex-wrap: wrap;
  justify-content: center;
  .award-box {
    position: relative;

    width: 6rem;
    height: 7.72rem;
    .lottery-lucky-box {
      display: flex;

      width: 100%;
      height: 100%;
      box-sizing: border-box;

      padding-top: 3rem;

      flex-direction: column;
      align-items: center;

      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;

      .lottery-lucky-text-box {
        display: flex;

        flex-direction: column;
        align-items: center;

        line-height: 0.6rem;
        font-weight: bold;
        .text {
          display: block;

          color: #fff;
        }
      }
    }

    .lose-lottery-img {
      width: 100%;
      height: 100%;
    }
  }
  .closedbtn {
    width: 0.6rem;
    height: 0.6rem;

    margin-top: 0.1rem;

    vertical-align: top;
  }
}
.package {
  position: absolute;
  top: -2rem;
  z-index: 3;
  animation: package_down 2s linear forwards;
  &.selected {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
  .package-inner {
    position: relative;

    width: 2.2rem;
    height: 3rem;
    overflow: hidden;
    .package-img {
      width: 8.8rem;
      height: 100%;
      &.package-img-open {
        animation: package_img_move 200ms steps(4) forwards;
      }
    }
    .coin-img-box {
      position: absolute;
      top: -0.5rem;
      left: -0.4rem;

      width: 3rem;
      height: 4rem;
      overflow: hidden;
      .coin-img {
        width: 45rem;
        height: 100%;
        animation: package_img_move 750ms steps(15) forwards;
      }
    }
  }
}
/* stylelint-disable */
// 红包下落动画
@keyframes package_down {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(120vh);
  }
}
// 红包图片播放动画
@keyframes package_img_move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
// 进度条播放动画
@keyframes progress_move {
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}
/* stylelint-enable */
</style>
